// Relinquish $.fn.datepicker back to jQuery UI and assign ab-datepicker's version to $.fn.abDatePicker
if ($.fn.datepicker && $.fn.datepicker.noConflict) {
    var abDatepicker = $.fn.datepicker.noConflict();
    $.fn.abDatePicker = abDatepicker;
}
